module.exports = __webpack_public_path__ + "static/media/cps_new.da02f855.svg";